import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './apikey.css';

const CreateApiKey = () => {
  const navigate = useNavigate();
  const [isSuccess, setIsSuccess] = useState(false);
  const [accountType, setAccountType] = useState('Spot Account');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  
  const [showSecret, setShowSecret] = useState(false);
  const apiKeyStr = "AGCXa1b2c3d4e5f6g7h8i9j0k1l2m3n4o5";
  const secretKeyStr = "Secr3tK3y1234567890abcdefghijKLMN";

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    alert('Copied to clipboard!');
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleBack = () => {
    navigate('/user_profile/api_keys');
  };
  return (
    <div className="api-create-container">
      {/* Breadcrumb */}
      <div className="api-breadcrumb">
        <span onClick={handleBack} style={{ cursor: 'pointer', color: '#6b7280' }}>API Management</span>
        <i className="ri-arrow-right-s-line"></i>
        <span className="current">Create New API Key</span>
      </div>

      {isSuccess ? (
        <div className="api-success-card">

          <div className='api_succssful_bl'>

            <div className="api-success-icon-wrapper">
              <div className="api-success-icon">
                <i className="ri-check-line"></i>
              </div>
            </div>
            <h2>API Key Created Successfully!</h2>
            <p>Your new API key has been created. Please copy your key and secret now.<br />You won't be able to see the secret key again.</p>

            <div className="api-success-box">
              <label>API Key</label>
              <div className="api-success-input">
                <input type="text" readOnly value={apiKeyStr} />
                <i className="ri-file-copy-line" style={{cursor: 'pointer'}} onClick={() => handleCopy(apiKeyStr)}></i>
              </div>
            </div>

            <div className="api-success-box">
              <label>Secret Key</label>
              <div className="api-success-input">
                <input type={showSecret ? "text" : "password"} readOnly value={secretKeyStr} />
                <i className={showSecret ? "ri-eye-line" : "ri-eye-off-line"} style={{cursor: 'pointer'}} onClick={() => setShowSecret(!showSecret)}></i>
                <i className="ri-file-copy-line" style={{cursor: 'pointer'}} onClick={() => handleCopy(secretKeyStr)}></i>
              </div>
            </div>

            <div className="api-success-actions">
              <button className="btn-view" onClick={handleBack}>View API Keys</button>
              <button className="btn-done" onClick={handleBack}>Done</button>
            </div>

          </div>

        </div>
      ) : (
        <div className="api-create-layout">
          {/* Left Form */}
          <div className="api-create-form-section">
            <h2>Create New API Key</h2>
            <p className="subtitle">Fill in the details below to generate a new API key.</p>

            <div className="api-form-group">
              <label>API Remark</label>
              <input type="text" placeholder="Trading Bot" />
              <span className="hint">Give your API key a name to remember its purpose.</span>
            </div>

            <div className="api-form-group">
              <label>Account Type</label>
              <div className="api-custom-select" ref={dropdownRef}>
                <div
                  className="api-select-trigger"
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                  {accountType}
                  <i className="ri-arrow-down-s-line"></i>
                </div>
                {isDropdownOpen && (
                  <ul className="api-select-options">
                    {['Spot Account', 'Margin Account', 'Futures Account'].map(type => (
                      <li
                        key={type}
                        className={accountType === type ? 'selected' : ''}
                        onClick={() => {
                          setAccountType(type);
                          setIsDropdownOpen(false);
                        }}
                      >
                        {type}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>

            <div className="api-form-group">
              <label>permissions</label>
              <div className="api-permissions-grid">
                <label className="api-perm-card active">
                  <input type="checkbox" defaultChecked />
                  <div className="api-perm-card-content">
                    <i className="ri-eye-line"></i>
                    <strong>Read</strong>
                    <span>View account balances, orders and market data.</span>
                  </div>
                </label>

                <label className="api-perm-card active">
                  <input type="checkbox" defaultChecked />
                  <div className="api-perm-card-content">
                    <i className="ri-arrow-left-right-line"></i>
                    <strong>Trade</strong>
                    <span>Place and cancel orders on your behalf.</span>
                  </div>
                </label>

                <label className="api-perm-card disabled">
                  <input type="checkbox" disabled />
                  <div className="api-perm-card-content">
                    <i className="ri-wallet-3-line"></i>
                    <strong>Withdraw</strong>
                    <span>Request withdrawals (Not recommended)</span>
                  </div>
                </label>
              </div>
            </div>

            <div className="api-form-group">
              <label>IP Whitelist <span className="optional">(optional)</span></label>
              <div className="api-ip-input-box">
                <div className="api-ip-chips">
                  <span className="api-ip-chip">192.168.1.10 <i className="ri-close-line"></i></span>
                  <span className="api-ip-chip">103.21.244.5 <i className="ri-close-line"></i></span>
                  <span className="api-ip-chip">182.16.12.8 <i className="ri-close-line"></i></span>
                </div>
                <input type="text" placeholder="" />
              </div>
              <span className="hint">Add up to 40 IP addresses separated by commas. Leave empty to allow all IPs.</span>
            </div>

            <div className="api-form-group">
              <label>API Passphrase <span className="optional">(optional)</span></label>
              <div className="api-input-with-icon">
                <input type="password" placeholder="passphraseplaceholder" />
                <i className="ri-eye-line"></i>
              </div>
              <span className="hint">Use a passphrase to add an extra layer of security to your API key.</span>
            </div>

            <div className="api-create-actions">
              <button className="btn-back" onClick={handleBack}><i className="ri-arrow-left-line"></i> Back</button>
              <button className="btn-submit" onClick={() => setIsSuccess(true)}>Create API Key</button>
            </div>
          </div>

          {/* Right Preview */}
          <div className="api-create-preview-section">
            <h3>API Key Preview</h3>
            <p className="subtitle">Review your API key information before creation.</p>

            <div className="api-preview-list">
              <div className="api-preview-item">
                <div className="preview-label">
                  <i className="ri-price-tag-3-line"></i> API Remark
                </div>
                <div className="preview-value"><strong>Trading Bot</strong></div>
              </div>

              <div className="api-preview-item">
                <div className="preview-label">
                  <i className="ri-user-line"></i> Account Type
                </div>
                <div className="preview-value"><strong>{accountType}</strong></div>
              </div>

              <div className="api-preview-item">
                <div className="preview-label">
                  <i className="ri-shield-check-line"></i> Permissions
                </div>
                <div className="preview-value">
                  <span className="preview-perm-badge">Read</span>
                  <span className="preview-perm-badge">Trade</span>
                </div>
              </div>

              <div className="api-preview-item">
                <div className="preview-label">
                  <i className="ri-global-line"></i> IP Whitelist
                </div>
                <div className="preview-value"><strong>192.168.1.10, 103.21.244.5, 182.16.12.8</strong></div>
              </div>

              <div className="api-preview-item">
                <div className="preview-label">
                  <i className="ri-lock-2-line"></i> API Passphrase
                </div>
                <div className="preview-value"><strong>************</strong></div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateApiKey;
